module.exports = __webpack_public_path__ + "static/book-cover-65ab2b688e7f5700f32b9999bd5c770d.jpeg";